import { useRef, useEffect } from 'react'
import { useAuthenticatedFetch } from './useAuthenticatedFetch'

export const useOptimizedComponentWillMount = (callback) => {
	const mounted = useRef(false)
	if (!mounted.current) callback()

	useEffect(() => {
		mounted.current = true
	}, [])
}

export { useAuthenticatedFetch }
